import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import Auth from './modules/auth'

export default new Vuex.Store({
  modules: { Auth },
  state: {
    userId:null,
    hasMap: false, //是否调起地图
  	parkLng: null, //选中的物流园经度
  	parkLat: null, //选中的物流园纬度
		loadingShow:false
  },
  mutations: {

  },
  actions: {

  }
})
